import { Overlay } from "@albelli/image-list-view"

export function makeTestOverlay(): Overlay {
  const noop = () => {
    /* IGNORE */
  }
  return (item: any, img: HTMLDivElement) => {
    img.setAttribute("data-tam", "image-item")
    return noop
  }
}
